<script setup lang="ts">
import { VLink } from '.'
import { Tab } from './types'

defineProps<{
  tabs: Tab[]
}>()
</script>

<template>
  <div class="border-b border-gray-200 dark:border-zinc-800">
    <nav
      class="relative -mb-px flex space-x-3 overflow-x-auto overflow-y-clip sm:space-x-6 sm:overflow-clip"
      aria-label="Tabs"
    >
      <template v-for="tab in tabs" :key="tab.name">
        <VLink
          class="relative flex cursor-pointer whitespace-nowrap border-b py-2 text-sm leading-6"
          :class="[
            tab.current
              ? 'border-current font-semibold text-[#3b88af]'
              : 'border-transparent font-medium text-gray-700 hover:border-gray-300 dark:text-zinc-300',
          ]"
          :to="tab.to"
          v-if="tab.visible === undefined || tab.visible"
        >
          <span class="relative z-10">{{ tab.name }}</span>
          <span
            v-if="tab.count"
            class="absolute -right-4 top-0 z-0 flex h-5 w-5 items-center justify-center rounded-full bg-red-600/90 text-[11px] font-medium text-white"
          >
            {{ tab.count }}
          </span>
          <div
            v-if="tab.current"
            class="pointer-events-none absolute -left-4 top-[41px] flex h-8 rotate-180 items-end overflow-hidden"
          >
            <div class="-mb-px flex h-[2px] w-24 rotate-180">
              <div
                class="w-full flex-none blur-sm [background-image:linear-gradient(-90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]"
              ></div>
              <div
                class="-ml-[100%] w-full flex-none blur-[1px] [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]"
              ></div>
            </div>
          </div>
        </VLink>
      </template>
    </nav>
  </div>
</template>
